import { render, staticRenderFns } from "./gamecard.vue?vue&type=template&id=9d175fbe&"
import script from "./gamecard.vue?vue&type=script&lang=js&"
export * from "./gamecard.vue?vue&type=script&lang=js&"
import style0 from "./gamecard.vue?vue&type=style&index=0&id=9d175fbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports